import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AppService } from "../app.service";

@Injectable({
  providedIn: "root",
})
export class BackOfficeGuard implements CanActivate {
  constructor(
    private router: Router,
    private appService: AppService,
  ) {}

  canActivate(): boolean {
    try {
      if (this.appService.appMode === "BACK_OFFICE") {
        // redirect to backOffice page
        this.router.navigate(["/backOffice"]);

        return false;
      }

      return true;
    } catch (error) {
      throw error;
    }
  }
}
